module.exports = __webpack_public_path__ + "media/recipes/111-1828a553.png";